import React from "react";
import { Button } from "@/components/ui/button";

const LandingPage = () => {
  const handleLogin = () => {
    const redirectUrl = `${window.location.origin}/app`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-teal-50">
      <div className="container mx-auto px-4 py-16">
        <header className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 text-gray-900" style={{ fontFamily: 'Merriweather, serif' }}>
            CC Seattle Community Center Network
          </h1>
          <p className="text-lg md:text-xl text-gray-700 max-w-2xl mx-auto mb-8" style={{ fontFamily: 'Inter, sans-serif' }}>
            Your all-in-one platform for jobs, events, articles, and meaningful discussions
          </p>
          <Button 
            data-testid="login-button"
            onClick={handleLogin}
            className="bg-gradient-to-r from-orange-500 to-coral-500 hover:from-orange-600 hover:to-coral-600 text-white px-8 py-6 text-lg rounded-full shadow-lg transition-all hover:scale-105"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Sign In
          </Button>
        </header>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto mt-20">
          <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-orange-100">
            <div className="text-4xl mb-4">💼</div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" style={{ fontFamily: 'Merriweather, serif' }}>Job Board</h3>
            <p className="text-gray-600" style={{ fontFamily: 'Inter, sans-serif' }}>Discover and post job opportunities</p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-teal-100">
            <div className="text-4xl mb-4">📅</div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" style={{ fontFamily: 'Merriweather, serif' }}>Events</h3>
            <p className="text-gray-600" style={{ fontFamily: 'Inter, sans-serif' }}>Browse and create community events</p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-amber-100">
            <div className="text-4xl mb-4">✍️</div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" style={{ fontFamily: 'Merriweather, serif' }}>Articles</h3>
            <p className="text-gray-600" style={{ fontFamily: 'Inter, sans-serif' }}>Share useful resources and links</p>
          </div>

          <div className="bg-white/80 backdrop-blur-sm p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all border border-orange-100">
            <div className="text-4xl mb-4">💬</div>
            <h3 className="text-xl font-bold mb-3 text-gray-900" style={{ fontFamily: 'Merriweather, serif' }}>Discussions</h3>
            <p className="text-gray-600" style={{ fontFamily: 'Inter, sans-serif' }}>Engage in community threads</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;